import React from 'react';

import {
  Box,
  CustomChip,
  Stack,
  Typography,
} from '@packages/fenrir/components';

import { useSecurityJourneyTranslations } from '../locales/use-security-journey-translations';

/* -------------------------------------------------------------------------------------------------
 * TechnicalDomainsList
 * -----------------------------------------------------------------------------------------------*/
type TechnicalDomainsListProps = {
  technicalDomains?: string[];
  color?: string;
};

export const TechnicalDomainsList = ({
  technicalDomains,
  color = 'text.secondary',
}: TechnicalDomainsListProps) => {
  /**
   * Get an instance of the translations
   */
  const { t } = useSecurityJourneyTranslations();

  if (technicalDomains === undefined) return;

  const primaryTechnicalDomain = technicalDomains[0];

  const secondaryTechnicalDomains = technicalDomains.slice(1);

  if (!primaryTechnicalDomain && secondaryTechnicalDomains.length === 0) {
    return (
      <Typography variant="body2" color={color}>
        -
      </Typography>
    );
  }

  if (primaryTechnicalDomain && secondaryTechnicalDomains.length === 0) {
    return (
      <Stack direction="row" gap={1}>
        <Typography component="span" variant="body2" color={color}>
          {primaryTechnicalDomain}
        </Typography>
        <CustomChip
          variant="unassigned"
          label={t('spidrLibrary.blueprintDetailsContent.primary')}
        />
      </Stack>
    );
  }

  return (
    <Box
      component="ul"
      marginLeft={2}
      fontSize="14px"
      sx={{
        listStyleType: 'disc',
        color,
      }}
    >
      {primaryTechnicalDomain && (
        <Box key={primaryTechnicalDomain} component="li">
          <Stack direction="row" gap={1}>
            <Typography color={color} variant="body2">
              {primaryTechnicalDomain}
            </Typography>
            <CustomChip
              variant="unassigned"
              label={t('spidrLibrary.blueprintDetailsContent.primary')}
            />
          </Stack>
        </Box>
      )}
      {secondaryTechnicalDomains.map((item: string) => (
        <Box key={item} component="li" sx={{ marginBottom: 0.5 }}>
          <Typography color={color} variant="body2">
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
